// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/configdelivery/config_delivery.proto (package ga.config_manager.configdelivery, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/configdelivery/config_delivery.proto.
 */
export const file_ga_config_manager_configdelivery_config_delivery: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message ga.config_manager.configdelivery.ApplyRequest
 */
export type ApplyRequest = Message<"ga.config_manager.configdelivery.ApplyRequest"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string service = 2;
   */
  service: string;

  /**
   * @generated from field: string branch = 3;
   */
  branch: string;

  /**
   * deploy without validation: the emergency bypass, allowed to superusers only
   *
   * @generated from field: string bypass_validation_reason = 4;
   */
  bypassValidationReason: string;
};

/**
 * Describes the message ga.config_manager.configdelivery.ApplyRequest.
 * Use `create(ApplyRequestSchema)` to create a new message.
 */
export const ApplyRequestSchema: GenMessage<ApplyRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 0);

/**
 * @generated from message ga.config_manager.configdelivery.ApplyResponse
 */
export type ApplyResponse = Message<"ga.config_manager.configdelivery.ApplyResponse"> & {
};

/**
 * Describes the message ga.config_manager.configdelivery.ApplyResponse.
 * Use `create(ApplyResponseSchema)` to create a new message.
 */
export const ApplyResponseSchema: GenMessage<ApplyResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 1);

/**
 * @generated from message ga.config_manager.configdelivery.ApplyProgress
 */
export type ApplyProgress = Message<"ga.config_manager.configdelivery.ApplyProgress"> & {
  /**
   * @generated from field: ga.config_manager.configdelivery.ApplyStage stage = 1;
   */
  stage: ApplyStage;

  /**
   * what is going on, for a person
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * the state of the apply in config-service, empty until the config is sent
   *
   * @generated from field: ga.config_manager.configdelivery.ApplyValidation validation = 3;
   */
  validation?: ApplyValidation;
};

/**
 * Describes the message ga.config_manager.configdelivery.ApplyProgress.
 * Use `create(ApplyProgressSchema)` to create a new message.
 */
export const ApplyProgressSchema: GenMessage<ApplyProgress> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 2);

/**
 * @generated from message ga.config_manager.configdelivery.ApplyValidation
 */
export type ApplyValidation = Message<"ga.config_manager.configdelivery.ApplyValidation"> & {
  /**
   * @generated from field: string apply_id = 1;
   */
  applyId: string;

  /**
   * the apply status of config-service without the prefix: VALIDATING, APPLIED...
   *
   * @generated from field: string apply_status = 2;
   */
  applyStatus: string;

  /**
   * the validation status without the prefix: PENDING, RUNNING, SUCCEEDED...
   *
   * @generated from field: string validation_status = 3;
   */
  validationStatus: string;

  /**
   * DeadlineExceeded, ImagePullBackOff, InputUnavailable...
   *
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: string job = 5;
   */
  job: string;

  /**
   * @generated from field: string image = 6;
   */
  image: string;
};

/**
 * Describes the message ga.config_manager.configdelivery.ApplyValidation.
 * Use `create(ApplyValidationSchema)` to create a new message.
 */
export const ApplyValidationSchema: GenMessage<ApplyValidation> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 3);

/**
 * @generated from message ga.config_manager.configdelivery.ContainerStatusesRequest
 */
export type ContainerStatusesRequest = Message<"ga.config_manager.configdelivery.ContainerStatusesRequest"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;
};

/**
 * Describes the message ga.config_manager.configdelivery.ContainerStatusesRequest.
 * Use `create(ContainerStatusesRequestSchema)` to create a new message.
 */
export const ContainerStatusesRequestSchema: GenMessage<ContainerStatusesRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 4);

/**
 * @generated from message ga.config_manager.configdelivery.ContainerStatusesResponse
 */
export type ContainerStatusesResponse = Message<"ga.config_manager.configdelivery.ContainerStatusesResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.configdelivery.ContainerStatusesResponse.Info infos = 1;
   */
  infos: ContainerStatusesResponse_Info[];
};

/**
 * Describes the message ga.config_manager.configdelivery.ContainerStatusesResponse.
 * Use `create(ContainerStatusesResponseSchema)` to create a new message.
 */
export const ContainerStatusesResponseSchema: GenMessage<ContainerStatusesResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 5);

/**
 * @generated from message ga.config_manager.configdelivery.ContainerStatusesResponse.Info
 */
export type ContainerStatusesResponse_Info = Message<"ga.config_manager.configdelivery.ContainerStatusesResponse.Info"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string image = 4;
   */
  image: string;

  /**
   * @generated from field: ga.config_manager.configdelivery.ContainerState state = 5;
   */
  state: ContainerState;
};

/**
 * Describes the message ga.config_manager.configdelivery.ContainerStatusesResponse.Info.
 * Use `create(ContainerStatusesResponse_InfoSchema)` to create a new message.
 */
export const ContainerStatusesResponse_InfoSchema: GenMessage<ContainerStatusesResponse_Info> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 5, 0);

/**
 * @generated from message ga.config_manager.configdelivery.AvailableServicesRequest
 */
export type AvailableServicesRequest = Message<"ga.config_manager.configdelivery.AvailableServicesRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;
};

/**
 * Describes the message ga.config_manager.configdelivery.AvailableServicesRequest.
 * Use `create(AvailableServicesRequestSchema)` to create a new message.
 */
export const AvailableServicesRequestSchema: GenMessage<AvailableServicesRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 6);

/**
 * @generated from message ga.config_manager.configdelivery.AvailableServicesResponse
 */
export type AvailableServicesResponse = Message<"ga.config_manager.configdelivery.AvailableServicesResponse"> & {
  /**
   * @generated from field: repeated string services = 2;
   */
  services: string[];
};

/**
 * Describes the message ga.config_manager.configdelivery.AvailableServicesResponse.
 * Use `create(AvailableServicesResponseSchema)` to create a new message.
 */
export const AvailableServicesResponseSchema: GenMessage<AvailableServicesResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 7);

/**
 * @generated from message ga.config_manager.configdelivery.ObfuscatedConfigsRequest
 */
export type ObfuscatedConfigsRequest = Message<"ga.config_manager.configdelivery.ObfuscatedConfigsRequest"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string service = 2;
   */
  service: string;

  /**
   * @generated from field: string branch = 3;
   */
  branch: string;
};

/**
 * Describes the message ga.config_manager.configdelivery.ObfuscatedConfigsRequest.
 * Use `create(ObfuscatedConfigsRequestSchema)` to create a new message.
 */
export const ObfuscatedConfigsRequestSchema: GenMessage<ObfuscatedConfigsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 8);

/**
 * @generated from message ga.config_manager.configdelivery.ObfuscatedConfigsResponse
 */
export type ObfuscatedConfigsResponse = Message<"ga.config_manager.configdelivery.ObfuscatedConfigsResponse"> & {
  /**
   * @generated from field: bytes body = 1;
   */
  body: Uint8Array;
};

/**
 * Describes the message ga.config_manager.configdelivery.ObfuscatedConfigsResponse.
 * Use `create(ObfuscatedConfigsResponseSchema)` to create a new message.
 */
export const ObfuscatedConfigsResponseSchema: GenMessage<ObfuscatedConfigsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_configdelivery_config_delivery, 9);

/**
 * @generated from enum ga.config_manager.configdelivery.ApplyStage
 */
export enum ApplyStage {
  /**
   * @generated from enum value: APPLY_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * the config is built from git and Vault
   *
   * @generated from enum value: APPLY_STAGE_BUILD = 1;
   */
  BUILD = 1,

  /**
   * the config is sent to config-service
   *
   * @generated from enum value: APPLY_STAGE_SEND = 2;
   */
  SEND = 2,

  /**
   * config-service validates the config
   *
   * @generated from enum value: APPLY_STAGE_VALIDATION = 3;
   */
  VALIDATION = 3,

  /**
   * the config is applied
   *
   * @generated from enum value: APPLY_STAGE_DONE = 4;
   */
  DONE = 4,
}

/**
 * Describes the enum ga.config_manager.configdelivery.ApplyStage.
 */
export const ApplyStageSchema: GenEnum<ApplyStage> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_configdelivery_config_delivery, 0);

/**
 * @generated from enum ga.config_manager.configdelivery.ContainerState
 */
export enum ContainerState {
  /**
   * @generated from enum value: CONTAINER_STATE_UNKNOW = 0;
   */
  UNKNOW = 0,

  /**
   * @generated from enum value: CONTAINER_STATE_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: CONTAINER_STATE_TERMINATED = 2;
   */
  TERMINATED = 2,

  /**
   * @generated from enum value: CONTAINER_STATE_WAITING = 3;
   */
  WAITING = 3,
}

/**
 * Describes the enum ga.config_manager.configdelivery.ContainerState.
 */
export const ContainerStateSchema: GenEnum<ContainerState> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_configdelivery_config_delivery, 1);

/**
 * @generated from service ga.config_manager.configdelivery.ConfigDeliveryService
 */
export const ConfigDeliveryService: GenService<{
  /**
   * @generated from rpc ga.config_manager.configdelivery.ConfigDeliveryService.Apply
   */
  apply: {
    methodKind: "unary";
    input: typeof ApplyRequestSchema;
    output: typeof ApplyResponseSchema;
  },
  /**
   * ApplyStream is Apply with its progress for the UI: the stages of the apply
   * and the state of the validation in config-service. The last message has
   * stage DONE; a failure ends the stream with the error Apply would return.
   *
   * @generated from rpc ga.config_manager.configdelivery.ConfigDeliveryService.ApplyStream
   */
  applyStream: {
    methodKind: "server_streaming";
    input: typeof ApplyRequestSchema;
    output: typeof ApplyProgressSchema;
  },
  /**
   * @generated from rpc ga.config_manager.configdelivery.ConfigDeliveryService.ContainerStatuses
   */
  containerStatuses: {
    methodKind: "unary";
    input: typeof ContainerStatusesRequestSchema;
    output: typeof ContainerStatusesResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.configdelivery.ConfigDeliveryService.AvailableServices
   */
  availableServices: {
    methodKind: "unary";
    input: typeof AvailableServicesRequestSchema;
    output: typeof AvailableServicesResponseSchema;
  },
  /**
   * from s3, created by bot
   *
   * @generated from rpc ga.config_manager.configdelivery.ConfigDeliveryService.DownloadObfuscatedConfigs
   */
  downloadObfuscatedConfigs: {
    methodKind: "unary";
    input: typeof ObfuscatedConfigsRequestSchema;
    output: typeof ObfuscatedConfigsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.configdelivery.ConfigDeliveryService.CreateObfuscatedConfigs
   */
  createObfuscatedConfigs: {
    methodKind: "unary";
    input: typeof ObfuscatedConfigsRequestSchema;
    output: typeof ObfuscatedConfigsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_configdelivery_config_delivery, 0);

